import { Box, Button } from 'edenred-ui';
import styled from 'styled-components';

export const DropdownButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  padding: 0 20px;
  background: none;
  border: none;
  text-align: left;
  color: ${({ theme }) => theme.primaryFrontColor};
  font-size: ${({ theme }) => theme.sizeMedium};
  font-family: ${({ theme }) => theme.fontFamily};

  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.altGray2};
  }

  &:hover {
    background: ${({ theme }) => theme.primaryBackColorLight10};
  }
`;

export const SmallButton = styled(Button)`
  height: 25px;
  min-height: 25px;
  padding: 0 10px;
  font-size: 12px;
  line-height: 1;
  box-sizing: border-box;
`;

export const GrayBorderSmallButton = styled(SmallButton)`
  font-size: 14px;
  border-radius: 4px;
  border-color: ${({ theme }) => theme.gray25};
`;

export const BorderLeft = styled(Box)`
  padding-left: 16px;
  border-left: solid 2px ${props => props.theme.primaryBackColorLight};
`;

export const PositiveLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 61px;
  height: 25px;
  padding: 4px 12px;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ theme }) => theme.fontSemiBold};
  line-height: 16px;
  background-color: ${({ theme }) => theme.positiveColor};
  color: ${({ theme }) => theme.primaryFontAltColor};
`;
